module.exports = __webpack_public_path__ + "images/onboarding/paige_thomas.jpg";